module.exports = __webpack_public_path__ + "4c8f11647fe2cf328b4cdd12cb2e65f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_18.jpg
// module id = 1699
// module chunks = 5